import { render, staticRenderFns } from "./HomeBanners.vue?vue&type=template&id=20496732&scoped=true&lang=pug"
import script from "./HomeBanners.vue?vue&type=script&lang=js"
export * from "./HomeBanners.vue?vue&type=script&lang=js"
import style0 from "./HomeBanners.vue?vue&type=style&index=0&id=20496732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20496732",
  null
  
)

export default component.exports